import React from "react";
import { FaCalendarTimes } from "react-icons/fa";

export default function ConvocationsEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center px-5 py-14 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-xl text-slate-400 dark:bg-slate-800">
        <FaCalendarTimes />
      </span>

      <h2 className="mt-4 font-semibold text-slate-800 dark:text-white">
        Aucun événement trouvé
      </h2>

      <p className="mt-1 max-w-md text-sm text-slate-500 dark:text-slate-400">
        Modifiez les filtres ou désactivez
        « Avec convocations » pour afficher les événements
        qui n’ont pas encore d’inscrit.
      </p>
    </div>
  );
}